import React, { Component } from 'react';
import { Modal, Form, Row, Col, AutoComplete, Input, InputNumber, Select, Radio, Checkbox, DatePicker, Upload, Button, Icon, message, Spin } from 'antd';
import $, { xToken } from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import FlowModal from '../flowChart';
import CommonFlowModal from '../flowChartCommon';
import CustomTable from './CustomTable';
import MultiInput from './MultiInput';
import './style.less';

const { Option } = Select;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const { MonthPicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const monthFormat = 'YYYY-MM';
const secondFormat = 'YYYY-MM-DD HH:mm:ss';

const formId = {};
const searchInputList = {};

class EditTemplateForm extends Component {
    state = {
        saveFlow: false,
        showFlowModal: false,
        showCommonFlowModal: false,
        flowParams: {},
        expandParams: {},
        canRead: 5,
        readFlag: false,
        loading: false,
    }

    timer = null

    componentDidMount() {
        const { form, edit, ssuHospitalStructureRead } = this.props;
        for (const [key, item] of Object.entries(searchInputList || {})) {
            const { getFieldDecorator } = form;
            getFieldDecorator(`${key}_list`, { initialValue: [] });
            edit && this.handleSearch(item.valueShow, item, 'immediate');
        }
        if(!ssuHospitalStructureRead || ssuHospitalStructureRead.flag != 1) {
            this.timer = setInterval(() => {
                this.setState({ canRead: this.state.canRead -1 }, () => {
                    if( this.state.canRead == 0) {
                        clearInterval(this.timer);
                    }
                })
            },1000)
        }else {
            this.setState({ canRead: 0, readFlag: true })
        }
    }

    showFlow = id => {
        const { hospitalId, form } = this.props;
        const { getFieldValue, getFieldsValue } = form;
        const values = getFieldsValue();
        const flowParams = { ...formId[id] };
        flowParams.hospitalId = hospitalId;
        flowParams.remark = values[`${id}_remark`];

        const refId = flowParams.ssuModuleStructureDefineRefId;
        const value = getFieldValue(refId) || [];

        const refItem = formId[refId] || {};
        const { ssuModuleStructureDefineWebType, ssuModuleStructureDefineOptionList } = refItem;

        let list;
        if (ssuModuleStructureDefineWebType === 'TEXT_MULTI_AREA') {
            list = value || [];
        } else {
            list = (ssuModuleStructureDefineOptionList || []).filter(item => value.indexOf(item.ssuModuleStructureDefineOptionId) >= 0)
                .map(i => i.ssuModuleStructureDefineOptionName);
        }
        this.setState({
            list,
            flowParams,
            showFlowModal: true,
        });
    }

    showCommonFlow = id => {
        const { hospitalId, form } = this.props;
        const { getFieldsValue } = form;
        const values = getFieldsValue();
        const flowParams = { ...formId[id] };
        flowParams.hospitalId = hospitalId;
        flowParams.remark = values[`${id}_remark`];

        this.setState({
            flowParams,
            showCommonFlowModal: true,
        });
    }

    hideFlow = (value, ssuModuleStructureDefineId, ssuHospitalStructureId) => {
        this.saveHospitalStructureId(ssuModuleStructureDefineId, ssuHospitalStructureId);
        this.setState({
            saveFlow: false,
            showFlowModal: false,
            showCommonFlowModal: false,
            ...value,
        }, () => {
            this.validateRequired(ssuModuleStructureDefineId);
        });
    }

    saveFlow = e => {
        this.setState({ saveFlow: true });
    }

    updateImgUrl = src => {
        this.props.updateImgUrl(src);
    }

    saveHospitalStructureId = (ssuModuleStructureDefineId, ssuHospitalStructureId) => {
        if (ssuHospitalStructureId) {
            formId[ssuModuleStructureDefineId].ssuHospitalStructureId = ssuHospitalStructureId;
        }
    }

    beforeUpload = file => {
        // const format = [
        //   'image/jpeg',
        //   'image/png',
        //   'application/pdf',
        //   'application/msword',
        //   'application/vnd.ms-excel',
        //   'application/x-zip-compressed',
        //   'application/vnd.ms-powerpoint',
        //   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        //   'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        // ];
        // const isInFormat = format.some((item) => { return file.type === item; });
        // if (!isInFormat) {
        //     message.warning('上传文件的格式不正确！');
        // }
        const isLt30M = (file.size / 1024 / 1024) < 30;
        if (!isLt30M) {
            message.warning('上传文件的大小不能超过30M！');
        }
        return isLt30M;
    }

    normFile = e => {
        const { file, fileList } = e;
        if (file.status && (file.status !== 'error')) {
            if (file.status == 'done' || file.status == 'uploading') {
                if (file.response && file.response.success) {
                    message.success(file.response.success);
                }
                if (file.response && file.response.ssuHospitalStructureId) {
                    this.saveHospitalStructureId(file.response.ssuModuleStructureDefineId, file.response.ssuHospitalStructureId);
                }
                const isExist = fileList.some(item => item.uid === file.uid);
                if (!isExist) {
                    fileList.push(file);
                }
            } else if (file.status == 'removed') {
                let removeIdx;
                fileList.forEach((item, index) => {
                    if (item.uid === file.uid) {
                        removeIdx = index;
                    }
                });
                if (removeIdx >= 0) {
                    fileList.splice(removeIdx);
                }
            }
        }
        return fileList;
    }

    handleRemove = (file, ssuModuleStructureDefineId) => {
        const options = {
            method: 'POST',
            url: API_URL.hospital.deleteSsuFile,
            data: {
                ssuFileUploadId: file.response.ssuFileUploadId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.validateRequired(ssuModuleStructureDefineId);
            },
        };
        $.sendRequest(options);
    }

    handleRemoveChart = item => {
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: '确定要删除吗?',
            onOk: () => {
                const options = {
                    method: 'POST',
                    url: API_URL.hospital.deleteSsuFlowChart,
                    data: {
                        ssuHospitalStructureId: item.ssuHospitalStructureId,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        if (!res.error) {
                            message.success(res.success);
                            formId[item.ssuModuleStructureDefineId].ssuFlowChartScreenshot = '';
                            this.setState({ [`${item.ssuModuleStructureDefineId}_flow`]: '' }, () => {
                                this.validateRequired(item.ssuModuleStructureDefineId);
                            });
                        }
                    },
                };
                $.sendRequest(options);
            },
        });
    }

    handleSearch = (value, item, type) => {
        const { ssuModuleStructureDefineId, ssuModuleStructureDefineName } = item;
        const { form: { setFieldsValue, getFieldValue } } = this.props;
        const queryData = () => {
            let keyword = value;
            if (value && value.indexOf('[') && (`${value}`).endsWith(']')) {
                keyword = value.slice(0, value.indexOf('['));
            }
            let options;
            if (ssuModuleStructureDefineName === '遗传办（主管部门）') {
                options = {
                    method: 'POST',
                    url: API_URL.hospital.querySsuModuleStructureHeredity,
                    data: {
                        limit: 20,
                        keyword,
                        ssuModuleStructureDefineId,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        const data = (res.data || []).map(i => {
                            const { ssuModuleStructureDefineOptionId, ssuModuleStructureDefineOptionName } = i;
                            return {
                                value: ssuModuleStructureDefineOptionId,
                                text: ssuModuleStructureDefineOptionName,
                                ...i,
                            };
                        });
                        setFieldsValue({ [`${ssuModuleStructureDefineId}_list`]: data });
                    },
                };
            } else {
                options = {
                    method: 'POST',
                    url: API_URL.investigation.queryUserByKey,
                    data: {
                        limit: 20,
                        keyword,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        const { datas } = res;
                        const data = (datas || []).map(i => {
                            const { userId, employeeCode, userCompellation } = i;
                            return {
                                value: userId,
                                text: `${userCompellation}[${employeeCode}]`,
                                ...i,
                            };
                        });
                        setFieldsValue({ [`${ssuModuleStructureDefineId}_list`]: data });
                    },
                };
            }
            $.sendRequest(options);
        };
        if (type === 'immediate') {
            queryData();
        } else {
            if (type === 'focus' && getFieldValue(`${ssuModuleStructureDefineId}_list`)) {
                return;
            }
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(queryData, 300);
        }
    }

    validateSearchInput = (rule, value, callback) => {
        const { id, name, required } = rule;
        const list = this.props.form.getFieldValue(`${id}_list`) || [];
        if (value) {
            const idx = list.findIndex(i => i.value == value);
            if (idx >= 0) {
                callback();
            } else {
                callback(`请选择正确的${name}`);
            }
        } else {
            required ? callback(`请选择${name}`) : callback();
        }
    }

    validateRequired = ssuModuleStructureDefineId => {
        setTimeout(() => {
            this.props.form.validateFields([`${ssuModuleStructureDefineId}`], { force: true });
        }, 50);
    }

    clearValue = field => {
        const { form: { setFieldsValue } } = this.props;
        setFieldsValue({ [field]: '' });
    }

    handleChange = (value, id) => {
        const { form: { setFieldsValue } } = this.props;
        setFieldsValue({ [id]: value });
    }

    // 处理webtype类型
    getWebType = item => {
        const { edit, form, hospitalId } = this.props;
        const { getFieldDecorator, getFieldValue } = form;
        const disabled = item.isDisabled === '1';
        const isRequire = item.ssuModuleStructureDefineIsRequire === '1';
        let dom = null;
        if (item.ssuModuleStructureDefineWebType == 'TEXT_RADIO') {
            const options = item.ssuModuleStructureDefineOptionList.map(i => (
                <Radio
                    key={i.ssuModuleStructureDefineOptionId}
                    value={i.ssuModuleStructureDefineOptionId}
                >{i.ssuModuleStructureDefineOptionName}</Radio>
            ));
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                rules: [{ required: isRequire, message: `请选择${item.ssuModuleStructureDefineName}` }],
                            })(
                                <RadioGroup disabled={disabled}>
                                    {options}
                                    {!disabled && <span className="clearValue" onClick={() => this.clearValue(item.ssuModuleStructureDefineId)}>×</span>}
                                </RadioGroup>,
                            )
                        :
                            getFieldValue(`${item.ssuModuleStructureDefineId}`)
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'TEXT_CHECKBOX') {
            const options = item.ssuModuleStructureDefineOptionList.map(i => ({
                label: i.ssuModuleStructureDefineOptionName,
                value: i.ssuModuleStructureDefineOptionId,
            }));
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                rules: [{ required: isRequire, message: `请选择${item.ssuModuleStructureDefineName}` }],
                            })(
                                <CheckboxGroup disabled={disabled} options={options} />,
                            )
                        :
                            getFieldValue(`${item.ssuModuleStructureDefineId}`)
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'TEXT_SELECT') {
            const options = item.ssuModuleStructureDefineOptionList.map(i => (
                <Option key={i.ssuModuleStructureDefineOptionId} value={String(i.ssuModuleStructureDefineOptionId)}>{i.ssuModuleStructureDefineOptionName}</Option>
            ));
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                rules: [{ required: isRequire, message: `请选择${item.ssuModuleStructureDefineName}` }],
                            })(
                                <Select disabled={disabled} placeholder={!disabled ? '请选择' : null} style={{ width: 240 }}>
                                    {options}
                                </Select>,
                            )
                        :
                            getFieldValue(`${item.ssuModuleStructureDefineId}`)
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'TEXT_SEARCH_INPUT') {
            searchInputList[item.ssuModuleStructureDefineId] = item;
            const list = getFieldValue(`${item.ssuModuleStructureDefineId}_list`) || [];
            const options = list.map(i => (
                <Option key={String(i.value)}>{i.text}</Option>
            ));
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                rules: [
                                    {
                                        required: isRequire,
                                        id: item.ssuModuleStructureDefineId,
                                        name: item.ssuModuleStructureDefineName,
                                        validator: this.validateSearchInput,
                                    },
                                ],
                            })(
                                <AutoComplete
                                    allowClear
                                    onSearch={value => this.handleSearch(value, item, 'search')}
                                    onFocus={() => this.handleSearch('', item, 'focus')}
                                    disabled={disabled}
                                    style={{ width: 240 }}
                                    placeholder={!disabled ? '输入检索' : null}
                                >
                                    {options}
                                </AutoComplete>,
                            )
                        :
                            getFieldValue(`${item.ssuModuleStructureDefineId}`)
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'TEXT_AREA') {
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            <div>
                                <Col span={15}>
                                    {
                                        getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                            rules: [{ required: isRequire, message: `请输入${item.ssuModuleStructureDefineName}` }],
                                        })(
                                            <Input maxLength="1000" disabled={disabled} placeholder={!disabled ? '请输入' : null} style={{ width: 240 }} />,
                                        )
                                    }
                                </Col>
                                { item.ssuModuleStructureDefineUnit }
                            </div>
                        :
                            <div>
                                { getFieldValue(`${item.ssuModuleStructureDefineId}`) }
                                { getFieldValue(`${item.ssuModuleStructureDefineId}`) && <span style={{ marginLeft: 5 }}>{item.ssuModuleStructureDefineUnit}</span>}
                            </div>
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'TEXT_MULTI_AREA') {
            const value = getFieldValue(item.ssuModuleStructureDefineId) || [];
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                            initialValue: [],
                            rules: [{ required: isRequire, message: `请输入${item.ssuModuleStructureDefineName}` }],
                        })(
                            <MultiInput edit={edit} list={value} onChange={value => this.handleChange(value, item.ssuModuleStructureDefineId)} />,
                        )
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'TEXT_TEXTAREA') {
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                rules: [{ required: isRequire, message: `请输入${item.ssuModuleStructureDefineName}` }],
                            })(
                                <TextArea maxLength="1000" disabled={disabled} placeholder={!disabled ? '请输入' : null} style={{ width: 240 }} />,
                            )
                        :
                            getFieldValue(`${item.ssuModuleStructureDefineId}`)
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'NUMBER_AREA') {
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            <div>
                                <Col span={15}>
                                    {
                                    getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                        rules: [{ required: isRequire, message: `请输入${item.ssuModuleStructureDefineName}` }],
                                    })(
                                        <InputNumber disabled={disabled} style={{ width: 240 }} />,
                                    )
                                }
                                </Col>
                                { item.ssuModuleStructureDefineUnit }
                            </div>
                       :
                            <div>
                                { getFieldValue(`${item.ssuModuleStructureDefineId}`) }
                                { getFieldValue(`${item.ssuModuleStructureDefineId}`) && <span style={{ marginLeft: 5 }}>{item.ssuModuleStructureDefineUnit}</span>}
                            </div>
                     }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'DATE_AREA') {
            let date;
            if (item.ssuDataFormat) {
                if (item.ssuDataFormat.ssuDataFormatValue == 'yyyy-MM-dd') {
                    date = <DatePicker disabled={disabled} placeholder={!disabled ? '请选择' : null} />;
                } else if (item.ssuDataFormat.ssuDataFormatValue == 'yyyy-MM') {
                    date = <MonthPicker disabled={disabled} placeholder={!disabled ? '请选择' : null} />;
                } else if (item.ssuDataFormat.ssuDataFormatValue == 'yyyy-MM-dd HH:mm:ss') {
                    date = <DatePicker disabled={disabled} placeholder={!disabled ? '请选择' : null} format="YYYY-MM-DD HH:mm:ss" showTime />;
                }
            }
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                rules: [{ type: 'object', required: isRequire, message: `请选择${item.ssuModuleStructureDefineName}` }],
                            })(
                                date,
                            )
                        :
                            getFieldValue(`${item.ssuModuleStructureDefineId}`)
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'FILE_UPLOAD') {
            const params = {
                hospitalId,
                curUserId: sessionStorage.userId,
                ssuModuleStructureId: item.ssuModuleStructureId,
                ssuModuleStructureDefineId: item.ssuModuleStructureDefineId,
            };
            if (item.ssuHospitalStructureId) {
                params.ssuHospitalStructureId = item.ssuHospitalStructureId;
            }
            let uploadDom = null;
            if (!edit) {
                const data = getFieldValue(`${item.ssuModuleStructureDefineId}`);
                if (data && data.length > 0) {
                    uploadDom = data.map(i => <p key={i.url}><a download href={i.url}>{i.name}</a></p>);
                }
            }
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                valuePropName: 'fileList',
                                getValueFromEvent: this.normFile,
                                rules: [{
                                    required: isRequire,
                                    message: `请上传${item.ssuModuleStructureDefineName}`,
                                }],
                            })(
                                <Upload
                                    action={API_URL.hospital.uploadSsuFile}
                                    data={{
                                        ...params,
                                        curUserId: sessionStorage.userId,
                                        curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                    }}
                                    beforeUpload={this.beforeUpload}
                                    onRemove={file => this.handleRemove(file)}
                                    headers={xToken}
                                >
                                    <Button>文件上传</Button>
                                </Upload>,
                            )
                        :
                            uploadDom
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'FLOW_CHART') {
            let src = this.state[`${item.ssuModuleStructureDefineId}_flow`];
            !src && (src = item.ssuFlowChartScreenshot);
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            <div>
                                {
                                    getFieldDecorator(`${item.ssuModuleStructureDefineId}`)(
                                        <Input type="hidden" />,
                                    )
                                }
                                { src && <img className="flow_img" src={src} onClick={() => this.updateImgUrl(src)} /> }
                                <a onClick={() => this.showFlow(item.ssuModuleStructureDefineId)}>{src ? '修改' : '设置'}</a>
                            </div>
                        :
                            <div>{ src && <img className="flow_img" src={src} onClick={() => this.updateImgUrl(src)} />}</div>
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'TABLE') {
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        getFieldDecorator(`${item.ssuModuleStructureDefineId}`)(
                            <Input type="hidden" />,
                        )
                    }
                    <CustomTable
                        edit={edit}
                        tableData={item || {}}
                        hospitalId={hospitalId}
                        saveHospitalStructureId={this.saveHospitalStructureId}
                    />
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'FILE_OR_CHART') {
            const params = {
                hospitalId,
                curUserId: sessionStorage.userId,
                ssuModuleStructureId: item.ssuModuleStructureId,
                ssuModuleStructureDefineId: item.ssuModuleStructureDefineId,
            };
            if (item.ssuHospitalStructureId) {
                params.ssuHospitalStructureId = item.ssuHospitalStructureId;
            }
            let uploadOrFlowDom = null;
            let src = this.state[`${item.ssuModuleStructureDefineId}_flow`];
            !src && (src = formId[item.ssuModuleStructureDefineId].ssuFlowChartScreenshot);
            const data = getFieldValue(`${item.ssuModuleStructureDefineId}`);
            if (!edit) {
                let uploadDom = null;
                if (data && data.length > 0) {
                    uploadDom = data.map(i => <p key={i.url}><a download href={i.url}>{i.name}</a></p>);
                }
                uploadOrFlowDom = (
                    <div>
                        {uploadDom}
                        {src && <img className="flow_img" style={{ marginTop: 6 }} src={src} onClick={() => this.updateImgUrl(src)} /> }
                    </div>
                );
            }

            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            <div>
                                {
                                    getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                        valuePropName: 'fileList',
                                        getValueFromEvent: this.normFile,
                                        rules: [{
                                            required: (src || !!(data && data.length)) ? false : isRequire,
                                            message: `请上传${item.ssuModuleStructureDefineName}`,
                                        }],
                                    })(
                                        <Upload
                                            action={API_URL.hospital.uploadSsuFile}
                                            data={{
                                                ...params,
                                                curUserId: sessionStorage.userId,
                                                curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                            }}
                                            beforeUpload={this.beforeUpload}
                                            onRemove={file => this.handleRemove(file, item.ssuModuleStructureDefineId)}
                                            headers={xToken}
                                        >
                                            <Button>文件上传</Button>
                                        </Upload>,
                                    )
                                }
                                <div style={{ marginTop: 6 }}>
                                    { src && <img className="flow_img" src={src} onClick={() => this.updateImgUrl(src)} /> }
                                    {
                                        src ?
                                            <span>
                                                <a onClick={() => this.showCommonFlow(item.ssuModuleStructureDefineId)}>修改</a>
                                                <span className="ant-divider" />
                                                <a onClick={() => this.handleRemoveChart(item)}>删除</a>
                                            </span>
                                        :
                                            <a onClick={() => this.showCommonFlow(item.ssuModuleStructureDefineId)}>绘制流程图</a>
                                    }
                                </div>
                            </div>
                        :
                            uploadOrFlowDom
                    }
                </span>
            );
        }
        return dom;
    }

    // 循环child中的必填项，将其加入到list中
    loopChildIsRequired = (child, requiredList) => {
        (child || []).forEach(item => {
            if (item.ssuModuleStructureDefineIsRequire === '1') {
                requiredList.push(item.ssuModuleStructureDefineId);
            }
            if (item.children && item.children.length > 0) {
                this.loopChildIsRequired(item.children, requiredList);
            }
        });
    }

    handleExpand = (ssuModuleStructureDefineId, children) => {
        const { expandParams } = this.state;
        const expandList = Object.keys(expandParams);
        const idx = expandList.findIndex(i => i == ssuModuleStructureDefineId);
        if (idx >= 0) {
            delete expandParams[ssuModuleStructureDefineId];
        } else {
            const requiredList = [];
            if (children && children.length > 0) {
                this.loopChildIsRequired(children, requiredList);
            }
            // 将一级字段下的必填项作为值列表，保存到对象中
            expandParams[ssuModuleStructureDefineId] = requiredList;
        }
        this.setState({ expandParams });
    }

    getContent = () => {
        const { templateData } = this.props;
        const { expandParams } = this.state;
        let content = null;
        if (templateData && templateData.length > 0) {
            content = templateData.map(item => {
                const { children, ssuModuleStructureDefineId, ssuModuleStructureDefineName } = item;
                const expandList = Object.keys(expandParams);
                const exist = expandList.find(i => i == ssuModuleStructureDefineId);
                return (
                    <div key={ssuModuleStructureDefineId}>
                        <div
                            style={{ position: 'relative', marginBottom: 10, fontSize: '14px', lineHeight: '42px', fontWeight: 'bold', borderBottom: '1px solid #999' }}
                        >
                            {ssuModuleStructureDefineName}
                            <a
                                style={{ position: 'absolute', top: 2, right: 10, fontWeight: 'normal', fontSize: '12px' }}
                                onClick={() => this.handleExpand(ssuModuleStructureDefineId, children)}
                            >
                                {exist ? '展开' : '收起'}
                                <Icon className="expand-icon" style={{ fontSize: '12px' }} type={exist ? 'down' : 'up'} />
                            </a>
                        </div>
                        <div style={{ height: exist ? 0 : 'auto', overflow: exist ? 'hidden' : 'unset' }}>
                            { children && children.length > 0 && this.getChildren(children) }
                        </div>
                    </div>
                );
            });
        }
        return content;
    }

    getShowState = data => {
        let isShow = false;
        const { edit, form } = this.props;
        const { getFieldValue } = form;
        if (data.ssuModuleStructureDefineDisplayDetailList && data.ssuModuleStructureDefineDisplayDetailList.length > 0) {
            if (data.oper == 'AND') {
                isShow = data.ssuModuleStructureDefineDisplayDetailList.every(item => {
                    const value = getFieldValue(item.refSsuModuleStructureDefineId);
                    const refValue = formId[item.refSsuModuleStructureDefineId].value || '';
                    if (item.detailOper == 'EQ') {
                        if (edit) {
                            if (Array.isArray(value)) {
                                return value.indexOf(Number(item.value)) >= 0;
                            }
                            return item.value == value;
                        }
                        return refValue.indexOf(item.value) >= 0;
                    } else if (item.detailOper == 'NEQ') {
                        if (edit) {
                            if (Array.isArray(value)) {
                                return value.indexOf(Number(item.value)) < 0;
                            }
                            return item.value != value;
                        }
                        return refValue.indexOf(item.value) < 0;
                    }
                });
            } else if (data.oper == 'OR') {
                isShow = data.ssuModuleStructureDefineDisplayDetailList.some(item => {
                    const value = getFieldValue(item.refSsuModuleStructureDefineId);
                    const refValue = formId[item.refSsuModuleStructureDefineId].value || '';
                    if (item.detailOper == 'EQ') {
                        if (edit) {
                            if (Array.isArray(value)) {
                                return value.indexOf(Number(item.value)) >= 0;
                            }
                            return item.value == value;
                        }
                        return refValue.indexOf(item.value) >= 0;
                    } else if (item.detailOper == 'NEQ') {
                        if (edit) {
                            if (Array.isArray(value)) {
                                return value.indexOf(Number(item.value)) < 0;
                            }
                            return item.value != value;
                        }
                        return refValue.indexOf(item.value) < 0;
                    }
                });
            }
        }
        return isShow;
    }

    getChildren = data => {
        const { edit, form } = this.props;
        const { getFieldDecorator, getFieldValue } = form;
        const leftItemLayout = {
            colon: false,
            labelCol: {
                sm: { span: 8 },
            },
            wrapperCol: {
                sm: { span: 15, offset: 1 },
            },
        };
        const rightItemLayout = {
            colon: true,
            labelCol: {
                sm: { span: 4, offset: 1 },
            },
            wrapperCol: {
                sm: { span: 19 },
            },
        };
        const content = data.map(item => {
            if (item.ssuModuleStructureDefineWebType != 'SET_OF_FIELDS') {
                formId[item.ssuModuleStructureDefineId] = item;
            }
            if (item.ssuModuleStructureDefineWebType == 'SET_OF_FIELDS') {
                return (
                    <div key={item.ssuModuleStructureDefineId}>
                        <div>{item.ssuModuleStructureDefineName}</div>
                        <div style={{ marginTop: 14, paddingLeft: 14 }}>
                            { item.children && item.children.length > 0 && this.getChildren(item.children) }
                        </div>
                    </div>
                );
            }
            const isAsterisk = (
                    item.ssuModuleStructureDefineIsAsterisk === '1' ?
                        <span style={{ float: 'left', lineHeight: '28px', color: 'red' }}>*</span>
                    :
                        <span style={{ float: 'left', lineHeight: '28px' }}>&nbsp;&nbsp;</span>
                );
            const isRemark = item.ssuModuleStructureDefineIsComment === '1';
            const isShow = item.ssuModuleStructureDefineDisplay ? this.getShowState(item.ssuModuleStructureDefineDisplay) : true;
            if (isShow) {
                return (
                    <Row key={item.ssuModuleStructureDefineId}>
                        <Col span={17} className="text_left">
                            <FormItem
                                {...leftItemLayout}
                                label={<div>{isAsterisk}<div className="text_left_label" title={item.ssuModuleStructureDefineName}>{item.ssuModuleStructureDefineName}</div></div>}
                            >
                                {this.getWebType(item)}
                            </FormItem>
                        </Col>
                        <Col span={7}>
                            {
                                    isRemark &&
                                    <FormItem label="备注" {...rightItemLayout}>
                                        {
                                        edit ?
                                            getFieldDecorator(`${item.ssuModuleStructureDefineId}_remark`, {
                                                rules: [{ required: false }],
                                            })(
                                                <Input maxLength="1000" style={{ width: 180 }} placeholder="请输入" />,
                                            )
                                        :
                                            getFieldValue(`${item.ssuModuleStructureDefineId}_remark`)
                                    }
                                    </FormItem>
                                }
                        </Col>
                    </Row>
                );
            }
        });
        return content;
    }

    handleSubmit = e => {
        e.preventDefault();
        const { hospitalId, ssuModuleStructureId, form } = this.props;
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                // 报错id是否在expandParams的值中，在：则删除
                const { expandParams } = this.state;
                const expandList = Object.keys(expandParams);
                if (expandList.length > 0) {
                    const errIdList = Object.keys(err);
                    let deleteId;
                    breakPoint: for (let i = 0, len = errIdList.length; i < len; i++) {
                        const errId = errIdList[i];
                        for (let j = 0, len = expandList.length; j < len; j++) {
                            const requireList = expandParams[expandList[j]] || [];
                            const exist = requireList.findIndex(i => i == errId);
                            if (exist >= 0) {
                                deleteId = expandList[j];
                                break breakPoint;
                            }
                        }
                    }
                    if (deleteId >= 0) {
                        delete expandParams[deleteId];
                        this.setState({ expandParams });
                    }
                }
                return;
            }
            let index = 0;
            const params = {};
            const array = Object.keys(values);
            array.forEach(item => {
                const key = Number(item);
                if (!isNaN(key) && formId[item]) {
                    const option = formId[item];
                    if (option.ssuHospitalStructureId) {
                        params[`ssuHospitalStructures[${index}].ssuHospitalStructureId`] = option.ssuHospitalStructureId;
                    }
                    if (option.ssuModuleStructureDefineWebType == 'TEXT_CHECKBOX') {
                        let text = '';
                        if (values[item]) {
                            text = values[item].join(',');
                        }
                        params[`ssuHospitalStructures[${index}].value`] = text;
                    } else if (option.ssuModuleStructureDefineWebType == 'DATE_AREA') {
                        let value = '';
                        if (option.ssuDataFormat) {
                            if (option.ssuDataFormat.ssuDataFormatValue == 'yyyy-MM-dd') {
                                value = values[item] && values[item].format(dateFormat);
                            } else if (option.ssuDataFormat.ssuDataFormatValue == 'yyyy-MM') {
                                value = values[item] && values[item].format(monthFormat);
                            } else if (option.ssuDataFormat.ssuDataFormatValue == 'yyyy-MM-dd HH:mm:ss') {
                                value = values[item] && values[item].format(secondFormat);
                            }
                        }
                        params[`ssuHospitalStructures[${index}].value`] = value;
                    } else if (option.ssuModuleStructureDefineWebType == 'TEXT_MULTI_AREA') {
                        params[`ssuHospitalStructures[${index}].value`] = (values[item] || []).join();
                    } else if (option.ssuModuleStructureDefineWebType == 'FILE_UPLOAD' || option.ssuModuleStructureDefineWebType == 'FILE_OR_CHART') {
                        params[`ssuHospitalStructures[${index}].value`] = (values[item] || []).map(i => i.response.ssuFileUploadId).join();
                    } else if (option.ssuModuleStructureDefineWebType == 'FILE_OR_CHART') {
                        params[`ssuHospitalStructures[${index}].value`] = '';
                    } else {
                        params[`ssuHospitalStructures[${index}].value`] = values[item];
                    }
                    params[`ssuHospitalStructures[${index}].type`] = 'HOSPITAL';
                    params[`ssuHospitalStructures[${index}].hospitalId`] = hospitalId;
                    params[`ssuHospitalStructures[${index}].ssuModuleStructureId`] = option.ssuModuleStructureId;
                    params[`ssuHospitalStructures[${index}].ssuModuleStructureDefineId`] = option.ssuModuleStructureDefineId;
                    params[`ssuHospitalStructures[${index}].ssuModuleStructureDefineWebType`] = option.ssuModuleStructureDefineWebType;
                    params[`ssuHospitalStructures[${index}].remark`] = values[`${item}_remark`];
                    index++;
                }
            });
            const options = {
                method: 'POST',
                url: API_URL.hospital.addSsuModuleStructureDetail,
                data: {
                    ssuModuleStructureId,
                    hospitalId,
                    ...params,
                },
                dataType: 'json',
                doneResult: res => {
                    if (!res.error) {
                        message.success(res.success);
                        this.props.changeEditState(false);
                    }
                },
            };
            $.sendRequest(options);
        });
    }

    changeEditState = value => {
        this.props.changeEditState(value);
    }

    //办事流程数据引用，具体逻辑由上层模板处理
    handleReference = () => {
        const { onReference } = this.props;
        onReference && onReference();
    }

    //已阅
    read = readFlag => {
        if(readFlag) return
        const { hospitalId, ssuModuleStructureId, form } = this.props;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.updateSsuHospitalStructureRead,
            data: {
                hospitalId,
                ssuModuleStructureId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success('标记完成');
                this.setState({ loading: false });
                this.props.loadData()
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { list = [], saveFlow, flowParams, showFlowModal, showCommonFlowModal, canRead, readFlag, loading } = this.state;
        const { edit, showEdit, showReference, canReferenceStructure, canEditStructure, needRead } = this.props;
        return (
            <div>
                <Spin spinning={loading}>
                <Form hideRequiredMark onSubmit={this.handleSubmit}>
                    <div style={{ maxHeight: 500, marginBottom: 10, background: '#fafafa', overflowY: 'auto' }}>
                        { this.getContent() }
                    </div>
                    {  
                        <FormItem
                            wrapperCol={{ span: 24 }}
                            style={{ textAlign: 'center'}}
                        >
                            {
                                needRead == 1 && !edit &&
                                <div style={{ textAlign: 'center', display: 'inline-block'}}>
                                    <Button
                                        key="read"
                                        type="primary"
                                        style={{ color:'rgba(0,0,0,.65)', backgroundColor: readFlag ? '#cccccc' : canRead > 0 ? '#fff' : '#ffcc00', borderColor: 'rgba(0,0,0,.5)'}}
                                        disabled={ canRead !== 0 }
                                        onClick={() => this.read(readFlag)}
                                    >
                                        {canRead !== 0 ? `已阅 (${canRead})s` : '已阅'}
                                    </Button>
                                </div>
                            }
                            {
                                showEdit && (canEditStructure === true) &&
                                <div style={{ display: 'inline-block'}}>
                                    {
                                        edit ?
                                            <div style={{ textAlign: 'center'}}>
                                                <Button
                                                    key="save"
                                                    type="primary"
                                                    htmlType="submit"
                                                    style={{ marginLeft: 20 }}
                                                >保存</Button>
                                                <Button
                                                    key="cancle"
                                                    type="primary"
                                                    style={{ marginLeft: 20 }}
                                                    onClick={() => this.changeEditState(false)}
                                                >取消</Button>
                                            </div>
                                        :
                                            <div style={{ textAlign: 'center' }}>
                                                {
                                                    showReference && (canReferenceStructure === true) &&
                                                    <Button
                                                        key="reference"
                                                        type="primary"
                                                        className="yellow"
                                                        style={{ marginLeft: 20 }}
                                                        onClick={this.handleReference}
                                                    >引用</Button>
                                                }
                                                <Button
                                                    key="edit"
                                                    type="primary"
                                                    style={{ marginLeft: 20 }}
                                                    onClick={() => this.changeEditState(true)}
                                                >编辑</Button>
                                            </div>
                                    }
                                </div>
                            }
                        </FormItem>
                    }
                </Form>
                {
                    showFlowModal &&
                    <Modal
                        title="流程图设置"
                        visible={showFlowModal}
                        onCancel={() => this.hideFlow()}
                        onOk={this.saveFlow}
                        className="preview-modal inv-detail"
                        wrapClassName="vertical-center-modal"
                        width="1000px"
                        confirmLoading={saveFlow}
                        maskClosable={false}
                    >
                        <FlowModal
                            list={list}
                            isSave={saveFlow}
                            params={flowParams}
                            hide={this.hideFlow}
                            isShow={showFlowModal}
                        />
                    </Modal>
                }
                {
                    showCommonFlowModal &&
                    <Modal
                        title="绘制流程图"
                        visible={showCommonFlowModal}
                        onCancel={() => this.hideFlow()}
                        onOk={this.saveFlow}
                        className="preview-modal inv-detail"
                        wrapClassName="vertical-center-modal"
                        width="1000px"
                        confirmLoading={saveFlow}
                        maskClosable={false}
                    >
                        <CommonFlowModal
                            isSave={saveFlow}
                            params={flowParams}
                            hide={this.hideFlow}
                            isShow={showCommonFlowModal}
                        />
                    </Modal>
                }
                </Spin>
            </div>
        );
    }
}

export default EditTemplateForm;



// WEBPACK FOOTER //
// ./src/components/common/workFlowTemplate/EditTemplateForm.js